import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserRolesEnum } from 'src/app/common/enums/user-roles-enum';
import { DialogsManagerService } from 'src/app/services/dialogs-manager.service';
import { UserManageService } from 'src/app/services/user-manage.service';

@Component({
    selector: 'app-review-create-user-dialog',
    templateUrl: './review-create-user-dialog.component.html',
    styleUrls: ['./review-create-user-dialog.component.css'],
    standalone: false
})
export class ReviewCreateUserDialogComponent {

  currentUser=this.userManageService.currentUser
  currentClinic=this.userManageService.currentClinic
  currentClinicList=this.userManageService.newUserClinicList
  currentOffice=this.userManageService.currentOffice
  UserRolesEnum=UserRolesEnum

  constructor( private dialogRef: MatDialogRef<any>,
    private dialogsManagerService: DialogsManagerService,private userManageService:UserManageService) { }

  goBack()
  {
    this.dialogsManagerService.isGoBack=true;
    this.dialogsManagerService.showCreateUserDialogComponent();
    this.dialogRef.close(`Excellent`);
  }

  onSubmit()
  {

    this.userManageService.createUser()
    this.dialogRef.close(`Excellent`);
    
  }
}
